import { render, staticRenderFns } from "./TeacherExit.vue?vue&type=template&id=2b53e9da"
import script from "./TeacherExit.vue?vue&type=script&lang=js"
export * from "./TeacherExit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports